import { render, staticRenderFns } from "./ProjectDropdown.vue?vue&type=template&id=1d2252ae&scoped=true&"
import script from "./ProjectDropdown.vue?vue&type=script&lang=js&"
export * from "./ProjectDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2252ae",
  null
  
)

export default component.exports